import { SchoolConfigurationLayout } from 'shared/graphql';

/**
 * Sorts an array of SchoolConfigurationLayout objects by their sidebarOrderNumber property in ascending order.
 * If sidebarOrderNumber is undefined, it is treated as 0.
 *
 * @param items - The array of SchoolConfigurationLayout objects to sort.
 * @returns A new array sorted by sidebarOrderNumber.
 */
export function sortLayoutRoutes(items: SchoolConfigurationLayout[]): SchoolConfigurationLayout[] {
  const copy = [...items];
  return copy.sort((a, b) => (a.sidebarOrderNumber ?? 0) - (b.sidebarOrderNumber ?? 0));
}
